import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import UserForm from './form';
import Loading from '../../components/general/loading/loading';
import { asyncGetUser } from '../../../services/users.service';

const EditUser = () => {
    const { idUser } = useParams();
    const [row, setRow] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        asyncGetUser(idUser).then((body: any) => {
            if (body.items !== undefined) {
                setRow(body.items);
                setLoading(false);
            }
        });
    }, [idUser]);

    return loading ? <Loading /> : <UserForm idUser={idUser} user={row} />;
};

export default EditUser;
